<template>
  <ul class="py-4">
    <li v-for="(celeb, index) in celebs" :key="index">
      <router-link
        :to="{
          path: '/celebs/',
          name: 'CelebDetails',
          params: {
            id: celeb.id
          }
        }"
        class="border-gray-600 border-b mb-4 pb-2 overflow-hidden flex item-center hover:opacity-50"
      >
        <div class="w-16 h-16 border border-gray-800 rounded-full mr-8">
          <img
            v-if="celeb['profile_path']"
            :src="profileImageUrl(celeb['profile_path'])"
            :alt="'loading...'"
            class="rounded-full w-full h-full"
          />
          <img
            v-else
            src="@/assets/images/avatar-icon.png"
            :alt="'loading...'"
            class="rounded-full w-full h-full"
          />
        </div>
        <div class="flex flex-col">
          <p class="xs:text-sm text-xs font-semibold mb-2">
            {{ celeb["name"] }}
          </p>
          <p class="block text-sm text-gray-500">
            {{
              celeb["known_for_department"] === "Acting"
                ? celeb["gender"] === 1
                  ? "Actress"
                  : "Actor"
                : celeb["known_for_department"]
            }}
          </p>
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["celebs"]
};
</script>
